import { gql } from '@apollo/client';

export default gql`
  mutation deletePlace($id: ID!) {
    deletePlace(input: { id: $id }) {
      success
    }
  }
`;
